import { render } from "./ChatPeopleBar.vue?vue&type=template&id=3a211476&ts=true"
import script from "./ChatPeopleBar.vue?vue&type=script&lang=ts"
export * from "./ChatPeopleBar.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__